// Import dependencies
import { html } from 'lit';

// Import global utils
import { addParametersUTM } from '@automator/shared/utils/add-parameters-utm-to-url';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __, sprintf } from '@wordpress/i18n';

/**
 * Retrieves directory fields data and sentence based on the given type.
 *
 * @param {String} type - The type of iterable expression (e.g., 'token').
 * @return {Object} An object containing directory fields data and sentence.
 */
const getLoop = ( type ) => {
	const directoryMap = {
		token: {
			fields: [
				{
					option_code: 'TOKEN',
					type: 'text',
					label: escapeHTML( __( 'Token', 'uncanny-automator' ) ),
					required: true,
					supports_tokens: true,
					only_loopable_tokens: true,
					show_label_in_sentence: false,
					clear_when_adding_token: true
				}
			],
			sentence: sprintf(
				/* translators: 1. Token name */
				escapeHTML( __( '{{Token:%1$s}}', 'uncanny-automator' ) ),
				'TOKEN'
			),
			dialog_helper: html`
				${ escapeHTML( __( 'Loop through tokens that contain multiple items, such as Woo products, LearnDash courses, BuddyBoss memberships, and more.', 'uncanny-automator' ) ) } <a href="${ addParametersUTM( 'https://automatorplugin.com/knowledge-base/token-loops/', { medium: 'token_loop_dialog', content: 'learn_more' } ) }" target="_blank">${ escapeHTML( __( 'Learn more', 'uncanny-automator' ) ) } <uo-icon id="external-link"></uo-icon></a>
			`
		}
	};

	return directoryMap[ type ] || {};
}

export default getLoop;
